<template>
  <div>
    <!-- 显示选中的商品 -->
    <v-card
      v-if="choseItem || (goodsDataList && goodsDataList.length > 0)"
      outlined
      class="mb-4"
    >
      <v-card-text>
        <v-layout align-center>
          <KImg
            :src="selectedGoodsImage"
            width="80"
            height="80"
            class="mr-3"
          />
          <v-flex>
            <div class="subtitle-1">
              {{ selectedGoodsName }}
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <template v-if="requiresPrice">
      <div class="title mb-3">
        填寫真實購買的商品數量和單價
      </div>

      <!-- 数量和价格输入 -->
      <v-layout align-center>
        <v-flex xs3>
          <v-text-field
            :value="itemQty"
            :rules="[v => !!v || '數量不能為空', v => v > 0 || '數量必須大於0']"
            label="商品數量"
            type="number"
            min="1"
            required
            @input="onItemQtyInput($event)"
          />
        </v-flex>

        <div class="text-center mx-4 title">
          ×
        </div>

        <v-flex xs3>
          <v-text-field
            :value="itemPrice"
            :rules="[v => !!v || '價格不能為空', v => v >= 0 || '價格不能小於0']"
            label="商品價格(人民幣)"
            type="number"
            min="0"
            step="0.01"
            required
            @input="onItemPriceInput($event)"
            @focus="onPriceFocus"
            @blur="onPriceBlur"
          />
        </v-flex>

        <div class="text-center mx-4 title">
          =
        </div>

        <v-flex xs3>
          <v-text-field
            :value="totalPriceDisplay"
            label="商品總價"
            type="number"
            min="0"
            step="0.01"
            @input="onTotalPriceInput($event)"
            @focus="onTotalPriceFocus"
            @blur="onTotalPriceBlur"
          />
        </v-flex>
      </v-layout>

      <!-- 提示信息 -->
      <v-alert
        v-show="priceFocused || totalPriceFocused"
        :value="true"
        type="warning"
        border="left"
        elevation="1"
        colored-border
        class="body-2 mt-2"
      >
        請務必如實填寫，金額不實會影響進出口通關
      </v-alert>
    </template>
    <!-- 包裹备注 -->
    <div class="mt-4">
      <v-text-field
        :value="memo"
        label="包裹備註（非必填）"
        placeholder="只有你自己看得到"
        @input="$emit('update:memo', $event)"
      />
    </div>

    <!-- 上传图片区域（可选，暂时注释） -->
    <!--
    <div class="mt-4">
      <div class="grey--text">
        賣家營業登記和訂單截圖（非必填）
      </div>
      <v-card
        outlined
        class="mt-2 pa-4 text-center"
        style="border: 2px dashed #ccc; cursor: pointer;"
      >
        <v-icon
          color="grey"
          size="48"
        >
          add
        </v-icon>
        <div class="caption mt-2 grey--text">
          點擊上傳圖片
        </div>
      </v-card>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'Step3PriceForm',
  props: {
    choseItem: {
      type: [Object, String],
      default: null
    },
    goodsDataList: {
      type: Array,
      default: () => []
    },
    itemQty: {
      type: [String, Number],
      default: '1'
    },
    itemPrice: {
      type: [String, Number],
      default: ''
    },
    memo: {
      type: String,
      default: ''
    },
    requiresPrice: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      priceFocused: false,
      manualTotalPrice: null,
      totalPriceFocused: false
    }
  },
  computed: {
    selectedGoodsImage () {
      if (this.choseItem) {
        return this.choseItem.itemPic || this.choseItem.pic_url || (this.choseItem.imageUrls && this.choseItem.imageUrls[0])
      }
      if (this.goodsDataList && this.goodsDataList.length > 0) {
        return this.goodsDataList[0].itemPic
      }
      return ''
    },
    selectedGoodsName () {
      if (this.choseItem) {
        return this.choseItem.title || this.choseItem.itemName
      }
      if (this.goodsDataList && this.goodsDataList.length > 0) {
        return this.goodsDataList[0].itemName
      }
      return ''
    },
    totalPrice () {
      if (this.manualTotalPrice !== null) {
        return parseFloat(this.manualTotalPrice).toFixed(2)
      }
      const qty = parseInt(this.itemQty) || 0
      const price = parseFloat(this.itemPrice) || 0
      return (qty * price).toFixed(2)
    },
    totalPriceDisplay () {
      if (this.totalPriceFocused && this.manualTotalPrice !== null) {
        return this.manualTotalPrice
      }
      return this.totalPrice
    }
  },
  methods: {
    onPriceFocus () {
      this.priceFocused = true
    },
    onPriceBlur () {
      this.priceFocused = false
    },
    onItemQtyInput (value) {
      this.manualTotalPrice = null
      this.$emit('update:itemQty', value)
    },
    onItemPriceInput (value) {
      this.manualTotalPrice = null
      this.$emit('update:itemPrice', value)
    },
    onTotalPriceFocus () {
      this.totalPriceFocused = true
    },
    onTotalPriceInput (value) {
      this.manualTotalPrice = value
    },
    onTotalPriceBlur () {
      this.totalPriceFocused = false
      const totalPrice = parseFloat(this.manualTotalPrice) || 0
      this.manualTotalPrice = totalPrice

      const qty = parseInt(this.itemQty) || 1
      if (qty > 0) {
        const newItemPrice = (totalPrice / qty).toFixed(2)
        this.$emit('update:itemPrice', newItemPrice)
      }
    }
  }
}
</script>
